// #region: Class definition *********************************************************************/
/**
 * @class ToolBar
 * @description Custom web component that renders a toolbar.
 * 
 * @extends WebComponent
 * Extends the WebComponent base class.
 *
 * @example
 * <tool-bar>
 *    <div class="tool-bar-group"></div>
 * </tool-tip>
*/
class ToolBar extends WebComponent {

    // #region: Constructor **********************************************************************/
    /**
     * Creates an instance of ToolTip.
     */
    constructor() {
        super();
    }
    // #endregion ********************************************************************************/

    // #region: Build ****************************************************************************/
    /**
     * Registered tag name for this web component.
     * This is used by the browser to identify and register the custom element.
     * @type {string}
     * 
     * @static
     * @memberof ToolBar
     */
    static tagName = 'tool-bar';

    /**
     * Identifies class instance.
     * @returns {string} The string representation of this class instance.
     * 
     * @memberof ToolBar
     */
    toString() {
        return '[ToolBar]';
    }

    /**
     * Identifies class.
     * @returns {string} The string representation of this class.
     * 
     * @static
     * @memberof ToolBar
     */
    static toString() {
        return '[ToolBar]';
    }

    /**
     * Identifies the version.
     * @returns {string} The version number of this class.
     * 
     * @static
     * @memberof ToolBar
     */
    static version() {
        return '1.0.0';
    }
    // #endregion ********************************************************************************/

    // #region: Public methods *******************************************************************/
    /**
     * Validate the content.
     * @returns {boolean} True if valid, false if not. Defaults to true.
     * 
     * @memberof ToolTip
     */
    validate() {
        return true;
    }
    // #endregion ********************************************************************************/

}
// #endregion ************************************************************************************/

/**
 * Register web component.
 * Defines the custom element 'tool-bar' and maps it to the ToolBar class.
 */
customElements.define(ToolBar.tagName, ToolBar);
